import { render, staticRenderFns } from "./UploadOneImage.vue?vue&type=template&id=08927c8e&"
import script from "./UploadOneImage.vue?vue&type=script&lang=js&"
export * from "./UploadOneImage.vue?vue&type=script&lang=js&"
import style0 from "./UploadOneImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports